// Import react lib
import { useState, useEffect } from 'react';

// Import services
import { getTextFromDocument } from '../libs/getTextFromDocument';

// Function to fetch a text document from a given URL
// and return its content as a string
export function useFetchTextFromDocument(url) {
    // State to store the text content and any error that occurs during fetching
    const [text, setText] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        // Reset the text and error state when the URL changes
        setText(null);
        setIsLoading(true);
        setIsError(false);

        async function fetchTextFromDocument(url) {
            try {
                // get the text document from the URL
                const text = await getTextFromDocument(url);
                setText(text);
            } catch (err) {
                console.error(
                    `Error while fetching text document\nError message: ${err.message}`,
                );
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        }

        fetchTextFromDocument(url);
    }, [url]);

    return { text, isLoading, isError };
}
